import React, { useContext } from "react";
import { ThemeContext } from "helpers/contexts.js";
import { BaseListItemHeader } from "./style";
import { COLOR } from "constant";
import PropTypes from "prop-types";

ListItemHeader.propTypes = {
  padding: PropTypes.string,
  borderColor: PropTypes.string,
  bgColor: PropTypes.string,
};
ListItemHeader.defaultProps = {
  padding: "12px 10px",
  bgColor: COLOR.white,
};

function ListItemHeader(props) {
  const theme = useContext(ThemeContext);
  const borderBottomColor = props.borderColor || theme.colors.transparent;

  return (
    <BaseListItemHeader
      borderBottom={borderBottomColor}
      backgroundColor={props.bgColor}
      padding={props.padding}
    >
      {props.children}
    </BaseListItemHeader>
  );
}

export default ListItemHeader;
